import { FModal, Icons } from '@components';
import { mdiPrinter } from '@mdi/js';
import { currency } from '@utils';
import React, { useCallback, useEffect, useState } from 'react';
import './styles.css';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { ResgateParcialService } from '@services';
import { dadosSimulacaoResgatePDF } from '../utils/resgate-parcial';

export const DetailsModal = ({
  modalIsOpen,
  setModalIsOpen,
  infosData,
  dadosPrevidenciarios,
  dadosEmprestimo,
}) => {
  const [pdf, setPDF] = useState('');
  const { matricula, nome, token } = useSelector((state) => state.user);
  const InfoDataDescription = dadosSimulacaoResgatePDF(
    infosData,
    dadosEmprestimo,
    dadosPrevidenciarios
  );

  const gerarSimulacaoResgateParcialPDF = useCallback(() => {
    // Remove regime não selecionado
    const titleToRemove =
      infosData.title === 'Regressivo' ? 'Progressivo' : 'Regressivo';
    delete InfoDataDescription[titleToRemove];

    const service = new ResgateParcialService();
    service
      .GerarSimulacaoResgateParcialPDF({
        ...InfoDataDescription,
        dtGeracao: format(new Date(), 'dd/MM/yyyy às HH:mm'),
        matricula,
        nome,
        token,
      })
      .then((base64) => {
        setPDF(`data:application/pdf;base64,${base64}`);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    gerarSimulacaoResgateParcialPDF();
  }, [gerarSimulacaoResgateParcialPDF]);

  return (
    <FModal
      isOpen={modalIsOpen}
      close
      widthAuto
      onClose={() => setModalIsOpen(false)}
    >
      <div className="modal-container">
        <div className="modal-header">
          <div className="modal-title-wrapper">
            <p>{`Regime ${infosData.title}`}</p>
          </div>
          <a
            href={pdf}
            rel="noreferrer"
            target="_blank"
            title="Clique para baixar o pdf"
            download={`Simulação de resgate parcial - ${matricula}.PDF`}
          >
            <Icons path={mdiPrinter} color="var(--orange_sign)" size={1} />
            Imprimir
          </a>
        </div>
        {!!infosData.params.contaIndividual && (
          <div className="result-container">
            <div className="result-title">
              <p>Conta Individual</p>
              <p>{currency(dadosPrevidenciarios.ValorIndividual)}</p>
            </div>
            <div className="tbrow" />
            {InfoDataDescription[infosData.title].contaIndividual.map(
              (item) => (
                <div key={item.label} className="result-values">
                  <p>{item.label}</p>
                  <p>{item.value}</p>
                </div>
              )
            )}
            <div className="tbrow" />
            <div className="result-values">
              <p>Valor previsto para liberação</p>
              <p className="result-total">
                {currency(
                  InfoDataDescription[infosData.title].valorLiberacaoIndividual
                )}
              </p>
            </div>
          </div>
        )}

        {!!infosData.params.contaAdicional && (
          <div className="result-container">
            <div className="result-title">
              <p>Conta Adicional</p>
              <p>{currency(dadosPrevidenciarios.ValorAdicional)}</p>
            </div>
            <div className="tbrow" />
            {InfoDataDescription[infosData.title].contaAdicional.map((item) => (
              <div key={item.label} className="result-values">
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            ))}
            <div className="tbrow" />
            <div className="result-values">
              <p>Valor previsto para liberação</p>
              <p className="result-total">
                {currency(
                  InfoDataDescription[infosData.title].valorLiberacaoAdicional
                )}
              </p>
            </div>
          </div>
        )}

        {!!infosData.params.contaEventual && (
          <div className="result-container">
            <div className="result-title">
              <p>Conta Eventual</p>
              <p>{currency(dadosPrevidenciarios.ValorEventual)}</p>
            </div>
            <div className="tbrow" />
            {InfoDataDescription[infosData.title].contaEventual.map((item) => (
              <div key={item.label} className="result-values">
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            ))}
            <div className="tbrow" />
            <div className="result-values">
              <p>Valor previsto para liberação</p>
              <p className="result-total">
                {currency(
                  InfoDataDescription[infosData.title].valorLiberacaoEventual
                )}
              </p>
            </div>
          </div>
        )}

        {!!infosData.params.contaPortabilidadeAberta && (
          <div className="result-container">
            <div className="result-title">
              <p>Conta Portabilidade Aberta</p>
              <p>{currency(dadosPrevidenciarios.ValorPortabilidadeAberta)}</p>
            </div>
            <div className="tbrow" />
            {InfoDataDescription[infosData.title].contaPortabilidadeAberta.map(
              (item) => (
                <div key={item.label} className="result-values">
                  <p>{item.label}</p>
                  <p>{item.value}</p>
                </div>
              )
            )}
            <div className="tbrow" />
            <div className="result-values">
              <p>Valor previsto para liberação</p>
              <p className="result-total">
                {currency(
                  InfoDataDescription[infosData.title]
                    .valorLiberacaoPortabilidadeAberta
                )}
              </p>
            </div>
          </div>
        )}

        <div className="result-container">
          <div className="result-title">
            <p>Detalhamento do resgate</p>
          </div>
          <div className="divider-orange" />
          {InfoDataDescription[infosData.title].detalhamento.map((item) => (
            <>
              <div key={item.label} className="result-values">
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
              {item.details &&
                item.details.map((detail) => (
                  <div key={detail.label} className="result-values-details">
                    <p>{detail.label}</p>
                    <p>{detail.value}</p>
                  </div>
                ))}
            </>
          ))}
          <div className="tbrow" />
          <div className="result-values">
            <p>Valor previsto para liberação</p>
            <p className="result-total">
              {currency(
                InfoDataDescription[infosData.title].valorLiberacaoTotal
              )}
            </p>
          </div>
        </div>
      </div>
    </FModal>
  );
};
